/** Only same origin paths, so a crafted link cannot send people to another site after sign in. */
export function safeRedirect(target: string | null | undefined, fallback = '/'): string {
  return target && target.startsWith('/') && !target.startsWith('//') ? target : fallback;
}

/** Where Supabase sends people back from confirmation and password reset emails. */
export function callbackUrl(next: string): string {
  return `${window.location.origin}/auth/callback?next=${encodeURIComponent(safeRedirect(next))}`;
}

export { authErrorMessage } from '@chipn/api-client';
